module.exports = __webpack_public_path__ + "static/img/base-img2.60bac7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/unifiedPortalPhone/base-img2.png
// module id = mj7V
// module chunks = 0